import React from "react";
import { useSelector } from "react-redux";
import Pdf from "./components/Pdf";
import Slides from "./components/Slides";
import _ from "lodash";

const ViewerViewing = () => {
  const room_data = useSelector((state) => state.gameReducer.roomObj);
  const slide_type = _.get(room_data, "game_state.slide_type");
  return <>{slide_type === "pdf" ? <Pdf /> : <Slides room_data={room_data} />}</>;
};

export default ViewerViewing;
